import React, { useEffect, useState } from "react";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { Calendar } from "primereact/calendar";
import { Button, TextField } from "@material-ui/core";
import moment from "moment";
import api from "utils/api";
import APIConstant from "utils/constant";
import cogoToast from "cogo-toast";
import { InputTextarea } from "primereact/inputtextarea";
import { CommonConfig } from "CommonConfig";
import { set } from "lodash";

const TransferOutward = (props) => {
  const [userId, setUserId] = useState("");
  const [outwardId, setOutwardId] = useState("");
  const [userPageAccess, setUserPageAccess] = useState([]);
  const [loading, setLoading] = useState(false);
  const [readOnly, setReadOnly] = useState(false);
  const [allowNegativeStock, setAllowNegativeStock] = useState(false);
  const [formData, setFormData] = useState({
    outwardDate: new Date(),
    outwardDateErr: false,
    outwardDateErrText: "",
    fromWarehouse: "",
    fromWarehouseErr: false,
    fromWarehouseErrText: "",
    toWarehouse: "",
    toWarehouseErr: false,
    toWarehouseErrText: "",
    remarks: "",
  });

  const [dropdownData, setDropdownData] = useState({
    warehouse: [],
    product: [],
    units: [],
  });

  const [itemStockList, setItemStockList] = useState([]);
  const [itemStockMap, setItemStockMap] = useState({});

  const [batchesList, setBatchesList] = useState({});
  const [editStockAdjustment, setEditStockAdjustment] = useState({});

  const [itemList, setItemList] = useState([
    {
      itemId: "",
      itemName: "",
      brandId: "",
      brandName: "",
      quantity: "",
      unit: "",
      unitName: "",
      batchNo: "",
      availableQuantity: "",
      barcode: "",
      id: "",
    },
  ]);

  useEffect(() => {
    let data = localStorage.getItem("Infodata");
    let userPageAccess = localStorage.getItem("PageAccess");
    setUserPageAccess(userPageAccess);
    setUserId(data);

    if (props.location?.state && props.location.state.OutwardId) {
      GetOutwardById(data);
      if (props.location.state.Type === "View") {
        setReadOnly(true);
      } else {
        GetProductMaster(data);
        GetWarehouseMaster(data);
        GetUnitMaster(data);
        GetBrandMaster(data);
        GetAuditOrderList(data);
        GetNegativeStockAccess(data);
      }
    } else {
      GetProductMaster(data);
      GetWarehouseMaster(data);
      GetUnitMaster(data);
      GetBrandMaster(data);
      GetAuditOrderList(data);
      GetNegativeStockAccess(data);
    }
  }, []);

  const GetProductMaster = async (UserId) => {
    let params = {
      UserId,
    };
    api
      .post(APIConstant.path.GetVariantList, params)
      .then(async (res) => {
        let response = await res;
        if (response.Success === 1) {
          let filterArry = response.Data.filter((x) => x.UserId != "Admin");
          setDropdownData((prevState) => ({
            ...prevState,
            product: filterArry,
          }));

          let itemBatchList = {};
          filterArry.forEach((product) => {
            itemBatchList[product.value] = product.Variant?.Batches.map(
              (batch) => ({
                ...batch,
                label: batch.BatchNo,
                value: batch._id,
              })
            );
          });
          setBatchesList(itemBatchList);
        }
      })
      .catch((err) => {});
  };

  const GetWarehouseMaster = async (UserId) => {
    let params = {
      UserId,
    };
    api
      .post(APIConstant.path.GetSubWareHouseList, params)
      .then(async (res) => {
        let response = await res;
        if (response.Success === 1) {
          let filterArry = response.Data.filter((x) => x.UserId != "Admin").map(
            (item) => ({
              ...item,
              label: item.Name,
              value: item._id,
            })
          );
          setDropdownData((prevState) => ({
            ...prevState,
            warehouse: filterArry,
          }));
        }
      })
      .catch((err) => {});
  };

  const GetUnitMaster = async (UserId) => {
    let params = {
      UserId,
    };
    api
      .post(APIConstant.path.GetUnitMaster, params)
      .then(async (res) => {
        let response = await res;
        if (response.Success === 1) {
          let filterArry = response.Data.filter((x) => x.UserId != "Admin");
          setDropdownData((prevState) => ({
            ...prevState,
            units: filterArry,
          }));
        }
      })
      .catch((err) => {});
  };

  const GetBrandMaster = async (UserId) => {
    let params = {
      UserId: UserId,
    };
    api
      .post(APIConstant.path.GetBrandMaster, params)
      .then((response) => {
        if (response.Success === 1) {
          let filterArry = response.Data.filter((x) => x.UserId != "Admin");
          setDropdownData((prevState) => ({
            ...prevState,
            brands: filterArry,
          }));
        }
      })
      .catch((err) => {});
  };

  const GetAuditOrderList = async (UserId) => {
    let params = {
      UserId,
    };
    api
      .post(APIConstant.path.GetAuditOrderList, params)
      .then((response) => {
        if (response.Success === 1) {
          let tempData = response.Data.map((res) => ({
            ...res,
            Quantity:
              res.QuantityDetails.reduce(
                (accumulator, current) => accumulator + current.Quantity,
                0
              ) || 0,
            Godown: res.QuantityDetails.length,
          }));
          setItemStockList(tempData);
          let tempMap = {};
          for (const item of tempData) {
            const itemId = item.ItemId;

            // Ensure structure exists
            if (!tempMap[itemId]) {
              tempMap[itemId] = { WithBatch: {}, WithoutBatch: {} };
            }

            // Handle BatchQuantityDetails
            for (const batch of item.BatchQuantityDetails || []) {
              const batchId = batch.BatchId;
              const subWarehouseId = batch.SubWarehouseId;
              const qty = batch.Quantity;

              if (!tempMap[itemId].WithBatch[batchId]) {
                tempMap[itemId].WithBatch[batchId] = {};
              }

              tempMap[itemId].WithBatch[batchId][subWarehouseId] = qty;
            }

            // Handle QuantityDetails (WithoutBatch)
            for (const qd of item.QuantityDetails || []) {
              const subWarehouseId = qd.SubWarehouseId;
              const qty = qd.Quantity;
              tempMap[itemId].WithoutBatch[subWarehouseId] = qty;
            }
          }
          setItemStockMap(tempMap);
        }
      })
      .catch((err) => {});
  };

  const GetVariantByBarcode = async (Barcode, index) => {
    let params = { UserId: userId, Barcode };
    api
      .post(APIConstant.path.GetVariantByBarcode, params)
      .then((response) => {
        if (response.Success === 1) {
          setItemList((prev) => {
            const updated = [...prev];
            let itemData = response.Data;

            updated[index].itemId = itemData.value;
            updated[index].brandId = itemData.Brand;
            updated[index].unit = itemData.UnitId;
            updated[index].originalUnit = itemData.UnitId;

            let tempBatch = itemData.Batch;
            if (tempBatch) {
              updated[index].batchNo = tempBatch._id;
            }

            return updated;
          });
        } else {
          cogoToast.error(response.Message);
        }
      })
      .catch(() => {});
  };

  const GetNegativeStockAccess = async (UserId) => {
    let params = {
      UserId: UserId,
      ConfigurationName: "Allow Negative Stock",
    };
    api
      .post(APIConstant.path.GetConfigurationByConfigurationName, params)
      .then(async (res) => {
        let response = await res;
        if (response.Success === 1) {
          if (response.Data) {
            setAllowNegativeStock(!!response.Data.ConfigurationValue);
          }
        }
      });
  };

  const GetOutwardById = async (UserId) => {
    try {
      let params = {
        UserId,
        OutwardId: props.location.state.OutwardId,
      };
      api
        .post(APIConstant.path.GetOutwardById, params)
        .then((response) => {
          if (response.Success === 1) {
            const {
              OutwardDate,
              FromWarehouse,
              FromWarehouseName,
              ToWarehouse,
              ToWarehouseName,
              ItemList,
              _id,
            } = response.Data;
            setFormData((prevState) => ({
              ...prevState,
              outwardDate: OutwardDate,

              fromWarehouse: FromWarehouse,
              fromWarehouseName: FromWarehouseName,

              toWarehouse: ToWarehouse,
              toWarehouseName: ToWarehouseName,
            }));
            let tempItemList = ItemList.map((item) => ({
              itemId: item.ItemId,
              itemName: item.ItemName,
              brandId: item.Brand,
              brandName: item.BrandName,
              quantity: item.Quantity,
              originalUnit: item.OriginalUnitId,
              unit: item.UnitId,
              unitName: item.UnitName,
              batchNo: item.BatchNoId,
              batchNoName: item.BatchNo,
              fromWarehouse: item.FromWarehouse,
              fromWarehouseName: item.FromWarehouseName,
              // currentQuantity: item.CurrentQuantity,
              barcode: item.Barcode,
              id: item?._id,
            }));
            setOutwardId(_id);
            let adjustMap = {};
            ItemList.forEach((item) => {
              if (!adjustMap[item.ItemId]) {
                adjustMap[item.ItemId] = { WithBatch: {}, WithoutBatch: {} };
              }

              if (item.BatchNoId) {
                if (!adjustMap[item.ItemId].WithBatch[item.BatchNoId]) {
                  adjustMap[item.ItemId].WithBatch[item.BatchNoId] = {};
                }
                adjustMap[item.ItemId].WithBatch[item.BatchNoId][
                  FromWarehouse
                ] = Number(item.Quantity);
              } else {
                adjustMap[item.ItemId].WithoutBatch[FromWarehouse] = Number(
                  item.Quantity
                );
              }
            });
            setEditStockAdjustment(adjustMap);
            setItemList(tempItemList);
          } else {
            // console.log(response.Message);
          }
        })
        .catch((err) => {});
    } catch (e) {
      console.log(e);
    }
  };

  const AddOutward = async () => {
    setLoading(true);

    if (!validate()) return setLoading(false);

    try {
      const payload = {
        OutwardDate: formData.outwardDate,
        OutwardType: "Transfer",
        FromWarehouse: formData.fromWarehouse,
        FromWarehouseName: dropdownData.warehouse.find(
          (item) => item.value === formData.fromWarehouse
        )?.label,
        ToWarehouse: formData.toWarehouse,
        ToWarehouseName: dropdownData.warehouse.find(
          (item) => item.value === formData.toWarehouse
        )?.label,
        Remarks: formData.remarks,
        UserId: userId,
        OutwardId: outwardId,
        ItemList: itemList.map((item) => {
          return {
            ItemId: item.itemId,
            ItemName: dropdownData.product.find(
              (obj) => obj.value === item.itemId
            )?.label,
            Brand: item.brandId,
            BrandName: dropdownData.brands.find(
              (obj) => obj.value === item.brandId
            )?.label,
            Quantity: item.quantity,
            UnitId: item.unit,
            UnitName: dropdownData.units.find((obj) => obj.value === item.unit)
              ?.label,
            OriginalUnitId: dropdownData.product.find(
              (it) => it.value === item.itemId
            )?.UnitId,
            BatchNoId: item.batchNo,
            BatchNo: batchesList[item.itemId]?.find(
              (obj) => obj.value === item.batchNo
            )?.label,
            AvailableQuantity: item.availableQuantity,
            Barcode: item.barcode,
            id: item.id,
          };
        }),
      };

      api
        .post(APIConstant.path.AddUpdateTransferOutward, payload)
        .then((res) => {
          if (res.Success == 1) {
            setLoading(false);
            cogoToast.success(res.Message);
            props.history.push("/admin/outward");
          } else {
            setLoading(false);
            cogoToast.error(res.Message);
          }
        });
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  };

  const validate = () => {
    let isValid = true;

    let updatedFormData = { ...formData };

    const formFieldsToValidate = [
      { key: "outwardDate", label: "Date" },
      { key: "fromWarehouse", label: "From Warehouse" },
      { key: "toWarehouse", label: "To Warehouse" },
    ];

    formFieldsToValidate.forEach(({ key, label }) => {
      if (CommonConfig.isEmpty(updatedFormData[key])) {
        isValid = false;
        updatedFormData[`${key}Err`] = true;
        updatedFormData[`${key}ErrText`] = `${label} is required`;
      } else {
        updatedFormData[`${key}Err`] = false;
        updatedFormData[`${key}ErrText`] = "";
      }
    });

    setFormData(updatedFormData);

    if (itemList.length <= 0) {
      cogoToast.error("Plese select Items");
      isValid = false;
    } else {
      itemList.forEach((item, index) => {
        if (CommonConfig.isEmpty(item.itemId)) {
          isValid = false;
        }
        if (CommonConfig.isEmpty(item.quantity)) {
          isValid = false;
        }
        if (CommonConfig.isEmpty(item.unit)) {
          isValid = false;
        }
      });
      if (!isValid) {
        cogoToast.error("Plese enter required fields");
      } else {
        itemList.forEach((item) => {
          if (item.availableQuantity < item.quantity && !allowNegativeStock) {
            isValid = false;
          }
        });
        if (!isValid) {
          cogoToast.error("Not Enough Stock");
        }
      }
    }
    return isValid;
  };

  const handleFormChange = (value, field, regex) => {
    // =========================
    // REQUIRED FIELD CHECK
    // =========================
    if (!value) {
      setFormData((prev) => ({
        ...prev,
        [field]: "",
        [`${field}Err`]: true,
        [`${field}ErrText`]: "This field is required",
      }));
      return;
    }

    // =========================
    // REGEX VALIDATION (IF ANY)
    // =========================
    if (regex && !regex.test(value)) return;

    // =========================
    // SPECIAL CASE: FROM WAREHOUSE CHANGE
    // =========================
    if (field === "fromWarehouse") {
      setItemList((prevItems) =>
        prevItems.map((item) => {
          if (!item.itemId) {
            return {
              ...item,
              availableQuantity: 0,
            };
          }

          const availableQty = getAvailableQty(
            item.itemId,
            item.batchNo,
            value // new fromWarehouse
          );

          return {
            ...item,
            availableQuantity: availableQty,
          };
        })
      );
    }

    // =========================
    // UPDATE FORM STATE
    // =========================
    setFormData((prev) => ({
      ...prev,
      [field]: value,
      [`${field}Err`]: false,
      [`${field}ErrText`]: "",
    }));
  };

  const getAvailableQty = (itemId, batchId, warehouseId) => {
    let qty = 0;

    // Base stock
    if (batchId) {
      qty = itemStockMap[itemId]?.WithBatch?.[batchId]?.[warehouseId] || 0;
    } else {
      qty = itemStockMap[itemId]?.WithoutBatch?.[warehouseId] || 0;
    }

    // 🔹 Add back edit quantity (ONLY IN EDIT MODE)
    if (outwardId && editStockAdjustment[itemId]) {
      if (batchId) {
        qty +=
          editStockAdjustment[itemId]?.WithBatch?.[batchId]?.[warehouseId] || 0;
      } else {
        qty += editStockAdjustment[itemId]?.WithoutBatch?.[warehouseId] || 0;
      }
    }

    return qty;
  };

  const handleItemListChange = (value, field, index, regex) => {
    // =========================
    // EMPTY VALUE HANDLING
    // =========================
    if (!value) {
      setItemList((prev) => {
        const updated = [...prev];
        if (field === "barcode") {
          value = value.toUpperCase();
        }
        updated[index] = {
          ...updated[index],
          [field]: value,
          [`${field}Err`]: true,
          [`${field}ErrText`]: "This field is required",
        };

        if (field === "lifeSpan") {
          updated[index].expiryDate = "";
        }

        return updated;
      });
      return;
    }

    // =========================
    // REGEX CHECK
    // =========================
    if (regex && !regex.test(value)) return;

    // =========================
    // UPDATE ITEM LIST
    // =========================
    setItemList((prev) => {
      const updated = [...prev];
      const current = { ...updated[index] };

      current[field] = value;
      current[`${field}Err`] = false;
      current[`${field}ErrText`] = "";

      // ======================================================
      // ITEM CHANGE
      // ======================================================
      if (field === "itemId") {
        const itemData = dropdownData.product.find((p) => p.value === value);

        if (itemData) {
          current.batchNo = "";
          current.batchNoName = "";
          current.brandId = itemData.Brand;
          current.unit = itemData.UnitId;
          current.originalUnit = itemData.UnitId;

          // 🔹 recalc available qty
          if (formData.fromWarehouse) {
            current.availableQuantity = getAvailableQty(
              value,
              null,
              formData.fromWarehouse
            );
          } else {
            current.availableQuantity = 0;
          }
        }
      }

      // ======================================================
      // BATCH CHANGE
      // ======================================================
      if (field === "batchNo") {
        if (current.itemId && formData.fromWarehouse) {
          current.availableQuantity = getAvailableQty(
            current.itemId,
            value,
            formData.fromWarehouse
          );
        } else {
          current.availableQuantity = 0;
        }
      }

      // ======================================================
      // QUANTITY / UNIT CHANGE (OPTIONAL RECALC)
      // ======================================================
      if (field === "quantity" || field === "unit") {
        if (current.itemId && formData.fromWarehouse) {
          current.availableQuantity = getAvailableQty(
            current.itemId,
            current.batchNo,
            formData.fromWarehouse
          );
        }
      }

      updated[index] = current;
      return updated;
    });
  };

  const handleKeyDown = (e, idx) => {
    if (e.key === "Enter") {
      try {
        if (itemList[idx].barcode) {
          GetVariantByBarcode(itemList[idx].barcode, idx);
        }
      } catch (err) {
        console.log(err);
      }
    }
  };

  const addItem = () => {
    setItemList((prev) => [
      ...prev,
      {
        itemId: "",
        itemName: "",
        brandId: "",
        brandName: "",
        quantity: "",
        unit: "",
        unitName: "",
        batchNo: "",
        fromWarehouse: "",
        fromWarehouseName: "",
        availableQuantity: "",
        barcode: "",
        id: "",
        // batchNoList: [],
      },
    ]);
  };

  const removeItem = (index) => {
    setItemList((prev) => prev.filter((_, i) => i !== index));
  };

  return (
    <>
      <div className="container-body e-container-body">
        <div className="conatiner-tab-body p-mt-3 p-mx-1 e-view-card">
          <div className="p-grid">
            <div className="p-sm-12 p-md-4">
              <div className="p-w-100 ">
                <div className="custom-inputs e-order-mng order">
                  <p className="text p-mb-1">From Warehouse</p>
                  {readOnly ? (
                    <p className="sub-text">{formData.fromWarehouseName}</p>
                  ) : (
                    <>
                      <div>
                        <Dropdown
                          filter
                          autoFocus
                          options={dropdownData.warehouse}
                          value={formData.fromWarehouse}
                          onChange={(e) =>
                            handleFormChange(e.value, "fromWarehouse")
                          }
                          placeholder="Warehouse"
                          className="p-w-100 e-input-common"
                        />
                      </div>
                      <span className="error-msg" style={{ color: "red" }}>
                        {formData.fromWarehouseErr
                          ? formData.fromWarehouseErrText
                          : null}
                      </span>
                    </>
                  )}
                </div>
              </div>
            </div>
            <div className="p-sm-12 p-md-4">
              <div className="p-w-100 ">
                <div className="custom-inputs e-order-mng order">
                  <p className="text p-mb-1">To Warehouse</p>
                  {readOnly ? (
                    <p className="sub-text">{formData.toWarehouseName}</p>
                  ) : (
                    <>
                      <div>
                        <Dropdown
                          filter
                          options={dropdownData.warehouse}
                          value={formData.toWarehouse}
                          onChange={(e) =>
                            handleFormChange(e.value, "toWarehouse")
                          }
                          placeholder="Warehouse"
                          className="p-w-100 e-input-common"
                        />
                      </div>
                      <span className="error-msg" style={{ color: "red" }}>
                        {formData.toWarehouseErr
                          ? formData.toWarehouseErrText
                          : null}
                      </span>
                    </>
                  )}
                </div>
              </div>
            </div>

            <div className="p-sm-12 p-md-4">
              <div className="p-w-100 ">
                <div className="custom-inputs e-order-mng order">
                  <p className="text p-mb-1">Transfer Date</p>
                  {readOnly ? (
                    <p className="sub-text">
                      {formData.outwardDate
                        ? moment(formData.outwardDate).format("DD/MM/YYYY")
                        : ""}
                    </p>
                  ) : (
                    <>
                      <div>
                        <Calendar
                          value={
                            formData.outwardDate
                              ? new Date(formData.outwardDate)
                              : null
                          }
                          onChange={(e) =>
                            handleFormChange(e.value, "outwardDate")
                          }
                          dateFormat="dd/mm/yy"
                          showIcon={false}
                          placeholder="Select Date"
                          className="p-w-100"
                          autoFocus
                        />
                      </div>
                      <span className="error-msg" style={{ color: "red" }}>
                        {formData.outwardDateErr
                          ? formData.outwardDateErrText
                          : null}
                      </span>
                    </>
                  )}
                </div>
              </div>
            </div>

            <div className="p-sm-12">
              <div className="p-w-100 ">
                <div className="custom-inputs e-order-mng order">
                  <p className="text p-mb-1">Remarks</p>
                  {readOnly ? (
                    <p className="sub-text">{formData.remarks}</p>
                  ) : (
                    <InputTextarea
                      className="p-w-100"
                      value={formData.remarks}
                      onChange={(e) =>
                        handleFormChange(e.target.value, "remarks")
                      }
                      maxLength={200}
                      placeholder="Remarks"
                    />
                  )}
                </div>
              </div>
            </div>
          </div>

          {itemList?.map((item, vIdx) => (
            <div
              key={vIdx}
              className="item-section p-mb-3"
              style={{
                background: "#fff",
                borderRadius: "8px",
                border: "2px dotted #bdbdbd",
                width: "100%",
                marginBottom: "12px",
                position: "relative",
                boxSizing: "border-box",
                transition: "border 0.2s",
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  background: "#f5f5f5",
                  borderRadius: "8px",
                  padding: "12px 20px",
                  marginBottom: "18px",
                  minHeight: "48px",
                }}
              >
                <span
                  style={{
                    fontWeight: "600",
                    color: "#09090B",
                    fontSize: "1rem",
                    letterSpacing: "0.5px",
                  }}
                >
                  Item {vIdx + 1}
                </span>
                {!readOnly && (
                  <Button
                    variant="outlined"
                    color="secondary"
                    onClick={() => removeItem(vIdx)}
                    style={{
                      minWidth: 120,
                      borderRadius: 8,
                      fontWeight: 500,
                      boxShadow: "0 1px 4px rgba(0,0,0,0.08)",
                      background: "#fff",
                    }}
                  >
                    <i className="pi pi-trash" style={{ marginRight: 8 }}></i>{" "}
                    Delete Item
                  </Button>
                )}
              </div>
              <div className="p-grid p-px-4">
                <div className="p-sm-12 p-md-3">
                  <div className="p-w-100 ">
                    <div className="custom-inputs e-order-mng order">
                      <p className="text p-mb-1">Raw Material/Item</p>
                      {readOnly ? (
                        <p className="sub-text">{item.itemName}</p>
                      ) : (
                        <>
                          <div>
                            <Dropdown
                              filter
                              options={dropdownData.product}
                              value={item.itemId}
                              onChange={(e) =>
                                handleItemListChange(e.value, "itemId", vIdx)
                              }
                              placeholder="Item"
                              className="p-w-100 e-input-common"
                            />
                          </div>
                          <span className="error-msg" style={{ color: "red" }}>
                            {item.itemErr ? item.itemErrText : null}{" "}
                          </span>
                        </>
                      )}
                    </div>
                  </div>
                </div>
                <div className="p-sm-12 p-md-3">
                  <div className="p-w-100 ">
                    <div className="custom-inputs e-order-mng order">
                      <p className="text p-mb-1">Barcode</p>
                      {readOnly ? (
                        <p className="sub-text">{item.barcode}</p>
                      ) : (
                        <InputText
                          value={item.barcode}
                          onChange={(e) =>
                            handleItemListChange(
                              e.target.value,
                              "barcode",
                              vIdx
                            )
                          }
                          maxLength={50}
                          onKeyDown={(e) => handleKeyDown(e, vIdx)}
                          placeholder="Barcode"
                          className="p-w-100 e-input-common"
                        />
                      )}
                    </div>
                  </div>
                </div>
                <div className="p-sm-12 p-md-3">
                  <div className="p-w-100 ">
                    <div className="custom-inputs e-order-mng order">
                      <p className="text p-mb-1">Brand Name</p>
                      {readOnly ? (
                        <p className="sub-text">{item.brandName}</p>
                      ) : (
                        <>
                          <div>
                            <Dropdown
                              filter
                              options={dropdownData.brands}
                              value={item.brandId}
                              onChange={(e) =>
                                handleItemListChange(e.value, "brandId", vIdx)
                              }
                              placeholder="Brand Name"
                              className="p-w-100 e-input-common"
                            />
                          </div>
                          <span className="error-msg" style={{ color: "red" }}>
                            {item.brandErr ? item.brandErrText : null}
                          </span>
                        </>
                      )}
                    </div>
                  </div>
                </div>
                <div className="p-sm-12 p-md-3">
                  <div className="p-w-100 ">
                    <div className="custom-inputs e-order-mng order">
                      <p className="text p-mb-1">Quantity</p>
                      {readOnly ? (
                        <p className="sub-text">{item.quantity}</p>
                      ) : (
                        <>
                          <div>
                            <InputText
                              value={item.quantity}
                              onChange={(e) =>
                                handleItemListChange(
                                  e.target.value,
                                  "quantity",
                                  vIdx,
                                  /^\d+(\.\d{0,2})?$/i
                                )
                              }
                              maxLength={10}
                              placeholder="Quantity"
                              className="p-w-100 e-input-common"
                            />
                          </div>
                          <span className="error-msg" style={{ color: "red" }}>
                            {item.quantityErr ? item.quantityErrText : null}{" "}
                          </span>
                        </>
                      )}
                    </div>
                  </div>
                </div>
                <div className="p-sm-12 p-md-3">
                  <div className="p-w-100 ">
                    <div className="custom-inputs e-order-mng order">
                      <p className="text p-mb-1">Unit</p>
                      {readOnly ? (
                        <p className="sub-text">{item.unitName}</p>
                      ) : (
                        <>
                          <div>
                            <Dropdown
                              filter
                              options={dropdownData.units}
                              value={item.unit}
                              onChange={(e) =>
                                handleItemListChange(e.value, "unit", vIdx)
                              }
                              placeholder="Unit"
                              className="p-w-100 e-input-common"
                            />
                          </div>
                          <span className="error-msg" style={{ color: "red" }}>
                            {item.unitErr ? item.unitErrText : null}{" "}
                          </span>
                        </>
                      )}
                    </div>
                  </div>
                </div>
                <div className="p-sm-12 p-md-3">
                  <div className="p-w-100 ">
                    <div className="custom-inputs e-order-mng order">
                      <p className="text p-mb-1">Batch No</p>
                      {readOnly ? (
                        <p className="sub-text">{item.batchNoName}</p>
                      ) : (
                        <>
                          <div>
                            <Dropdown
                              filter
                              options={batchesList[item.itemId] || []}
                              value={item.batchNo}
                              onChange={(e) =>
                                handleItemListChange(e.value, "batchNo", vIdx)
                              }
                              placeholder="Batch No"
                              className="p-w-100 e-input-common"
                            />
                          </div>
                          <span className="error-msg" style={{ color: "red" }}>
                            {item.batchNoErr ? item.batchNoErrText : null}
                          </span>
                        </>
                      )}
                    </div>
                  </div>
                </div>
                <div className="p-sm-12 p-md-3">
                  <div className="p-w-100 ">
                    <div className="custom-inputs e-order-mng order">
                      <p className="text p-mb-1">Available Quantity</p>
                      {readOnly ? (
                        <p className="sub-text">{item.availableQuantity}</p>
                      ) : (
                        <InputText
                          value={item.availableQuantity}
                          disabled
                          maxLength={10}
                          placeholder="Available Quantity"
                          className="p-w-100 e-input-common"
                        />
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
          {!readOnly && (
            <Button
              variant="outlined"
              color="primary"
              onClick={addItem}
              className="add-item-btn"
            >
              <i className="pi pi-plus" style={{ marginRight: 8 }}></i> Add Item
            </Button>
          )}
        </div>
      </div>
      <div className="p-d-flex p-ai-center p-jc-start e-inward-footer">
        <button
          className="secondary-btn"
          onClick={() => {
            props.history.push("/admin/outward");
          }}
        >
          Cancel
        </button>
        {readOnly ? null : (
          <Button
            className="primary-btn color-white p-ml-1"
            onClick={AddOutward}
            disabled={loading}
          >
            Submit
          </Button>
        )}
      </div>
    </>
  );
};

export default TransferOutward;
